import { createContext, useContext, useEffect, useReducer } from "react";
import {
  testExitReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/testExitReducer";
import axios from "../../api/axios";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities";
import { useParams } from "react-router-dom";
import { STATUS_EXCUTED, STATUS_IN_PROGRESS, STATUS_NOT_LOADED, STOCK_NOT_VAILABLE, TYPE_HAND_OUT } from "../../api/constant";
import { LOADED } from "../../api/constant";
const TestFormExitContext = createContext({});
const TestExitProvider = ({ children }) => {
  const { test_id, movement_id } = useParams();
  const [state, dispatch] = useReducer(testExitReducer, INITIAL_STATE);
  const { lookForCode, lookForProvider } = state;
  const typeOutExit = TYPE_HAND_OUT[0];
  useEffect(() => {
    if (movement_id) {
      axios()
        .get(`inventory/header_movement/${movement_id}`)
        .then(({ data }) => {
          dispatch({
            type: types.SET_PAYLOAD_MOVEMENT,
            payload: {
              ...state.movement,
              movement_id: data.id,
              status_id: data.status_id,
              to_edit: false,
              quantity: data.quantity_references,
              warehouse_id: data.warehouse_id,
            },
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [movement_id]);

  useEffect(() => {
    loadVersion();
    loadItemsTest();
    loadObservations();
    loadDocuments();
  }, [state.movement.movement_id]);
  useEffect(() => {
    if (
      state.movement.movement_id &&
      state.movement.document.status === STATUS_NOT_LOADED
    ) {
      loadDocuments();
    }
  }, [state.movement.document]);
  useEffect(() => {
    if (
      state.movement.movement_id &&
      state.movement.observation.status === STATUS_NOT_LOADED
    ) {
      loadObservations();
    }
  }, [state.movement.observation]);
  useEffect(() => {
    if (
      state.items_version.status === STATUS_NOT_LOADED &&
      state.movement.movement_id
    ) {
      loadItemsTest();
    }
  }, [state.items_version.status]);

  const loadObservations = () => {
    if (state.movement.movement_id) {
      axios()
        .get(
          `inventory/header_movement/${state.movement.movement_id}/getObservations`
        )
        .then(({ data }) => {
          dispatch({
            type: types.OBSERVATIONS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const loadDocuments = () => {
    if (state.movement.movement_id) {
      axios()
        .get(
          `inventory/header_movement/${state.movement.movement_id}/documents`
        )
        .then(({ data }) => {
          dispatch({
            type: types.DOCUMENTS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const addDocumentsToMovement = async (pictures) => {
    for await (const document of pictures) {
      var formData = new FormData();
      formData.append("document", document);
      await axios()
        .post(
          `inventory/header_movement/${state.movement.movement_id}/documented`,
          formData
        )
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
    dispatch({ type: types.RELOAD_DOCUMENTS });
  };
  const addObservation = (note) => {
    if (state.movement.movement_id) {
      axios()
        .post(
          `inventory/header_movement/${state.movement.movement_id}/notificated`,
          {
            note,
          }
        )
        .then(({ data }) => {
          dispatch({ type: types.RELOAD_OBSERTATIONS });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const loadItemsTest = () => {
    if (state.movement.movement_id) {
      axios()
        .get(
          `inventory/loadItemsByVersion/${test_id}/${state.movement.movement_id}`
        )
        .then(({ data }) => {
          dispatch({
            type: types.SET_PAYLOAD_ITEMS_VERSION,
            payload: {
              ...state.items_version,
              items: data,
              status: LOADED,
            },
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  /**
   * This function loads a version by making an HTTP GET request and updates the state with the
   * retrieved data.
   */
  const loadVersion = () => {
    axios()
      .get(`inventory/getVersionByIdWithParent/${test_id}`)
      .then(({ data }) => {
        dispatch({
          type: types.SET_PAYLOAD_TEST,
          payload: {
            ...state.movement,
            type: data.type,
            description: data.description,
            name: data.name,
            version: data.version,
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  /* The `createExitVersion` function is making an HTTP POST request to the
`inventory/createVersionExit/` endpoint using the `axios` library. If the request is
successful, it dispatches an action to update the state with the retrieved data, including the
`movement_id` and `to_edit` properties. If the request fails, it shows an error message using the
`showTypeErrorFetch` function. */
  const createExitVersion = () => {
    axios()
      .post(`inventory/createVersionExit/${test_id}`, {
        warehouse_id: state.movement.warehouse_id,
        quantity: state.movement.quantity,
        type: typeOutExit.code
      })
      .then(({ data }) => {
        dispatch({
          type: types.SET_PAYLOAD_MOVEMENT,
          payload: {
            ...state.movement,
            movement_id: data.id,
            status_id: data.status_id,
            to_edit: false,
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const getInventoryToTestAndItemId = (test_detail) => {
    const { item_id, abreviature, id } = test_detail;
    dispatch({
      type: types.SET_ITEM_SELECTED_OUT,
      payload: {
        abreviature,
        measure_id: "",
        test_detail_id: id,
        quantity_consume: test_detail.quantity * state.movement.quantity,
      },
    });
    axios()
      .get(
        `inventory/getInventoryToTestAndItemId/${id}/${state.movement.movement_id}/${item_id}`
      )
      .then(({ data }) => {
        dispatch({
          type: types.SET_PAYLOAD_INVENTORY_ITEM,
          payload: {
            ...state.inventory_item,
            items: data,
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const setConsume = (value, index) => {
    state.inventory_item.items[index].consume = value;
    dispatch({ type: types.FRESH_STATUS_INVENTORY });
  };
  const addOutToMovement = async(index_inventory_item) => {
    const item_inventory = state.inventory_item.items[index_inventory_item];
    let addOutToMOvement = await createOutMovementDetail(state.movement.movement_id,{
      value_unit_conversion: item_inventory.value_unit_conversion,
      item_id: item_inventory.item_id,
      consume: item_inventory.consume,
      lote: item_inventory.lote,
      test_detail_id: state.item_selected_out.test_detail_id,
      date_expired:item_inventory.date_expired,
      inventory_parent_lote: item_inventory.inventory_parent_lote ? item_inventory.inventory_parent_lote : item_inventory.inventory_parent_lote_id,
      stock_in_equivalent_measure_main: item_inventory.stock_in_equivalent_measure_main
    })
    if (addOutToMOvement==STOCK_NOT_VAILABLE) {
      setConsume(0, index_inventory_item);
    }
  };
  const createOutMovementDetail=async(movement_parent_id,form)=>{
    return axios()
    .post(`inventory/addOutToMovement/${movement_parent_id}`, form)
    .then(({ data }) => {
      dispatch({
        type: types.REFRESH_STATUS_ITEMS_VERSION,
        payload: STATUS_NOT_LOADED,
      });
      return data
    })
    .catch((e) => {
      showTypeErrorFetch(e);
      return e.response.data.message;
    });
  }
  const finishOutTest = () => {
    dispatch({
      type: types.SET_PAYLOAD_MOVEMENT,
      payload: {
        ...state.movement,
        status_id: STATUS_EXCUTED,
      },
    });
    axios()
      .put(`inventory/finishOutTest/${state.movement.movement_id}/${test_id}`)
      .then(({ data }) => {})
      .catch((e) => {
        dispatch({
          type: types.SET_PAYLOAD_MOVEMENT,
          payload: {
            ...state.movement,
            status_id: STATUS_IN_PROGRESS,
          },
        });
        showTypeErrorFetch(e);
        dispatch({
          type: types.REFRESH_STATUS_ITEMS_VERSION,
          payload: STATUS_NOT_LOADED,
        });
      });
  };
  return (
    <TestFormExitContext.Provider
      value={[
        state,
        dispatch,
        {
          createExitVersion,
          getInventoryToTestAndItemId,
          setConsume,
          addOutToMovement,
          finishOutTest,
          addDocumentsToMovement,
          addObservation,
          createOutMovementDetail
        },
      ]}
    >
      {children}
    </TestFormExitContext.Provider>
  );
};
const useMovement = () => useContext(TestFormExitContext)[0];
const useDispatchTestExit = () => useContext(TestFormExitContext)[1];
const useActionsTestExit = () => useContext(TestFormExitContext)[2];

export {
  TestFormExitContext,
  useMovement,
  useDispatchTestExit,
  useActionsTestExit,
};
export default TestExitProvider;
